import React from 'react';

function InputError(props) {
 
  if ( props.errors[props.field] ) {
      return <div className="validationError">{props.errors[props.field]}</div>
  }
  return <div></div>;
}
export default InputError;